import { Code, Instruction, Register } from "@geeki/iced-x86";
import { Patch } from "..";

const patches: Patch[] = [
    {
        type: 'base',
        name: '.text',
        base: 0x180000000 + 0x1000 - 0x400,
    },
    {
        type: "union",
        name: "选择机台模式",
        va: 0x1808FA582,
        patches: [
            { name: "LDJ", patch: [0x02] },
            { name: "TDJ", patch: [0x03] }
        ],
    },
    {
        name: "在 LDJ 模式下使用自定义帧数",
        patches: [
            { va: 0x1806CD773, off: [0x75], on: [0xEB] },
            { va: 0x1808FA397, off: [0x74, 0x03], on: [0x90, 0x90] },
        ],
    },
    {
        type: "union",
        name: "(需启用上面的补丁) 选择自定义的帧数",
        tooltip: "如高刷显示器不支持 120Hz, 请使用 CRU 或 NVIDIA 控制面板增加一个自定义的 120Hz 的分辨率, 通常来说这些高刷显示器支持 120Hz 是完全没有问题的。",
        va: 0x1808FA181,
        patches: [
            {
                name: "60 FPS",
                patch: [0xC7, 0x45, 0xDB, 0x3C, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xFF, 0x01, 0x00, 0x00, 0x00, 0x48, 0x8B, 0x45, 0xD7, 0x48, 0x89, 0x45, 0x03, 0xC7, 0x45, 0xD7, 0x01, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xDB, 0x3C, 0x00, 0x00, 0x00],
            },
            {
                name: "120 FPS",
                patch: [0xC7, 0x45, 0xDB, 0x78, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xFF, 0x01, 0x00, 0x00, 0x00, 0x48, 0x8B, 0x45, 0xD7, 0x48, 0x89, 0x45, 0x03, 0xC7, 0x45, 0xD7, 0x01, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xDB, 0x78, 0x00, 0x00, 0x00],
            },
        ],
    },
    {
        name: '-',
        type: 'splitter',
    },
    {
        type: "union",
        name: "选择显示器检测目标 FPS",
        tooltip: "如高刷显示器不支持 120Hz, 请使用 CRU 或 NVIDIA 控制面板增加一个自定义的 120Hz 的分辨率, 通常来说这些高刷显示器支持 120Hz 是完全没有问题的。",
        va: 0x1807F9226,
        patches: [
            {
                name: "60 FPS",
                patch: [0x3C, 0x00],
            },
            {
                name: "120 FPS",
                patch: [0x78, 0x00],
            },
        ]
    },
    {
        name: "快速显示器检测 (禁用重试)",
        tooltip: "加快显示器检测速度。如使用 60FPS 请勾选, 否则就算没问题也会 MONITOR ERROR",
        patches: [
            { va: 0x1807F1791, on: [0xE9, 0xA7, 0x00, 0x00, 0x00, 0x90], off: [0x0F, 0x8C, 0xA6, 0x00, 0x00, 0x00] },
            { va: 0x1807F1889, on: [0xEB], off: [0x7D] }
        ]
    },
    {
        name: '-',
        type: 'splitter',
    },
    {
        type: "union",
        name: "选择音频输出模式",
        tooltip: "游戏不吃 SOUND_OUTPUT_DEVICE 环境变量了, spice 也拿他没办法",
        va: 0x18092C7D3,
        patches: [
            {
                name: "不修改",
                patch: [0xE8, 0x98, 0xC4, 0xEC, 0xFF, 0x83, 0x78, 0x08, 0x03],
            },
            {
                name: "WASAPI",
                patch: [0xBB, 0x00, 0x00, 0x00, 0x00, 0xEB, 0x16, 0x90, 0x90],
            },
            {
                name: "ASIO",
                patch: [0xBB, 0x01, 0x00, 0x00, 0x00, 0xEB, 0x16, 0x90, 0x90],
            },
        ]
    },
    {
        name: "启用 WASAPI 共享模式",
        tooltip: "推荐使用 Windows 自带声卡驱动并且在 spice2x 内启用 -sp2x-lowlatencysharedaudio",
        patches: [{ va: 0x18046E37B, off: [0x44, 0x8B, 0xF2], on: [0x4D, 0x31, 0xF6] }],
    },
    {
        name: "阻止调整系统音量",
        tooltip: "spice2x 现在自带这个功能了快去更新吧",
        type: "tooltip",
    },
    {
        name: "最大游戏音量",
        tooltip: "忽略游戏内音量设置转而使用最大音量, 适用于声音很轻的情况。当你想要使用 TDJ 自带的耳机音量调节时请勿开启。",
        patches: [{ va: 0x18091BEF5, off: [0xFF, 0x90, 0x98, 0x00, 0x00, 0x00, 0x90], on: [0x90, 0x90, 0x90, 0x90, 0x90, 0x90, 0x90] }],
    },
    {
        name: "启用 BMSoundLib 日志输出",
        tooltip: '游戏启动不了时可以用这个进行除错',
        patches: [{
            va: 0x1803B1921,
            /*
             * lea     rcx, aBmsoundlib ; "BMSoundLib"
             * jmp     cs:avs2_log_warn
             */
            on: [
                0x8D, 0x0D, 0xD1, 0xA3, 0x8C, 0x00, 0xE9, 0xE6, 0x49, 0x59, 0x00, 0x90, 0x90, 0x90,
            ],
            off: [
                0x89, 0x54, 0x24, 0x10, 0x4C, 0x89, 0x44, 0x24, 0x18, 0x4C, 0x89, 0x4C, 0x24, 0x20,
            ]
        }],
    },
    {
        name: '-',
        type: 'splitter',
    },
    {
        name: "PF 倒计时冻结",
        patches: [{ va: 0x18075396D, off: [0x7E], on: [0xEB] }],
    },
    {
        name: "菜单倒计时倒涨",
        tooltip: "倒计时变正计时",
        patches: [{
            va: 0x18082969D + 1,
            off: [0x8B],
            on: [0x83]
        }],
    },
    {
        name: "选曲游标锁定",
        patches: [{ va: 0x1807B099D, off: [0x74, 0x22], on: [0x90, 0x90] }],
    },
    {
        name: "开始时按住 START 一直暂停歌曲",
        patches: [{ va: 0x1807D1F27, off: [0x7D, 0x36], on: [0x90, 0x90] }],
    },
    {
        type: 'asm',
        name: "更快的快速重试",
        tooltip: "缩短 'STAGE FAILED' 动画的长度.",
        arch: 'x86-64',
        patches: [{
            va: 0x1807D1365,
            on: [
                Instruction.create(Code.Nopd),
                Instruction.create(Code.Nopd),
            ],
            off: [
                Instruction.createBranch(Code.Jl_rel8_64, 0x1807D1365n + 0x14n),
            ]
        }],
    },
    {
        type: 'asm',
        name: '游玩黑谱不消耗 V-Disc',
        tooltip: '可无限玩黑谱',
        arch: 'x86-64',
        patches: [{
            va: 0x1804CAC50,
            on: [
                Instruction.create(Code.Retnq),
                Instruction.create(Code.Nopd),
                Instruction.create(Code.Nopd),
            ],
            off: [
                Instruction.createRegReg(Code.Test_rm64_r64, Register.R8, Register.R8),
            ]
        }]
    },
    {
        name: '-',
        type: 'splitter',
    },
    {
        name: "歌曲全解",
        patches: [{ va: 0x18074D69A, off: [0x32, 0xC0], on: [0xB0, 0x01] }],
    },
];

export default patches;
